import { api } from './api';

export interface Entity {
  id: string;
  workspaceId: string;
  parentId: string | null;
  name: string;
  currency: string;
  ownershipPct: number;
  eliminateIntercompany: boolean;
  isPrimary: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEntityBody {
  name: string;
  currency: string;
  parentId?: string | null;
  ownershipPct?: number;
  eliminateIntercompany?: boolean;
}

export interface UpdateEntityBody {
  name?: string;
  currency?: string;
  parentId?: string | null;
  ownershipPct?: number;
  eliminateIntercompany?: boolean;
}

export const entitiesApi = {
  async list(workspaceId: string): Promise<Entity[]> {
    const r = await api.get<Entity[]>(`/api/workspaces/${workspaceId}/entities`);
    return r.data;
  },
  async create(workspaceId: string, body: CreateEntityBody): Promise<Entity> {
    const r = await api.post<Entity>(`/api/workspaces/${workspaceId}/entities`, body);
    return r.data;
  },
  async update(entityId: string, body: UpdateEntityBody): Promise<Entity> {
    const r = await api.patch<Entity>(`/api/entities/${entityId}`, body);
    return r.data;
  },
  async delete(entityId: string): Promise<void> {
    await api.delete(`/api/entities/${entityId}`);
  },
};
